import React from 'react';
import '../../Assets/Components/Loading.css';

export default function Loading() {
    return (
        <div className="k-loading-mask">
            <span className="k-loading-text">Loading</span>
            <div className="images"></div>
            <div className="k-loading-color"></div>
        </div>
    )
}
